import React, { useState } from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import Bluebutton from "../../components/blueButton/Bluebutton";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Container from "react-bootstrap/Container";
import Arrow from "./Arrow3.png";
import "./services.css";
import Img1 from "./img1.png";
import Briefcase from "./ph_briefcase.png";
import { Link } from "react-router-dom";
import ArrowTop from "./ArrowTop.png";
import {
  FaIndustry,
  FaBroadcastTower,
  FaShoppingCart,
  FaTools,
  FaSeedling,
  FaGraduationCap,
  FaClinicMedical ,
  FaShip,
  FaVideo,
  FaFlask,
  FaOilCan,
  FaHardHat,
} from "react-icons/fa";
// import ManufacturingIcon from "./manufacturing.png";
// import TelecomIcon from "./telecom.png";
// import EcommerceIcon from "./ecommerce.png";
// import HealthIcon from "./health.png";
// import InfrastructureIcon from "./infrastructure.png";
// import OilGasIcon from "./oil_gas.png";
// import ChemicalIcon from "./chemical.png";
// import FertilizerIcon from "./fertilizer.png";
// import MediaIcon from "./media.png";
// import ConstructionIcon from "./construction.png";
// import EducationIcon from "./education.png";
// import ShippingIcon from "./shipping.png";

const workingAreas = [
  {
    title: "Manufacturing",
    description:
      "Optimizing processes and solutions for manufacturing industries.",
    icon: FaIndustry,
  },
  {
    title: "Telecom",
    description:
      "Providing innovative communication solutions for seamless connectivity.",
    icon: FaBroadcastTower,
  },
  {
    title: "Retail & E-Commerce",
    description:
      "Empowering businesses with end-to-end retail and e-commerce strategies.",
    icon: FaShoppingCart,
  },
  {
    title: "Health",
    description:
      "Enhancing healthcare systems with technology and expert solutions.",
    icon: FaClinicMedical ,
  },
  {
    title: "Infrastructure & Engineering",
    description:
      "Delivering robust solutions for large-scale infrastructure projects.",
    icon: FaHardHat,
  },
  {
    title: "Oil & Natural Gas",
    description:
      "Supporting energy industries with tailored services and expertise.",
    icon: FaOilCan,
  },
  {
    title: "Chemical",
    description:
      "Driving innovation in the chemical sector through advanced solutions.",
    icon: FaFlask,
  },
  {
    title: "Fertilizer",
    description:
      "Boosting agricultural productivity with effective fertilizer solutions.",
    icon: FaSeedling,
  },
  {
    title: "Media",
    description:
      "Creating impactful content and strategies for media enterprises.",
    icon: FaVideo,
  },
  {
    title: "Construction",
    description: "Building sustainable and innovative construction solutions.",
    icon: FaTools,
  },
  {
    title: "Education",
    description:
      "Enhancing learning experiences with modern educational tools.",
    icon: FaGraduationCap,
  },
  {
    title: "Port & Shipping",
    description:
      "Streamlining logistics and operations in the shipping industry.",
    icon: FaShip,
  },
];

const OurWorkingAreas = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone_number: "",
    email: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <>
      <Navb />
      {/* <Container className="pageHeader text-center py-5">
        <h1 className="Heading43"></h1>
        <p>
          
        </p>
        <Bluebutton Text="Learn More" Link="contact" />
      </Container> */}
      <Container
        className="mt-2 teamContainer mb-5"
        style={{ "background-color": "var(--primary-color)" }}
      >
        <div className="Heading43 mt-5 mt-lg-0 mb-3 text-white text-center">
          Driving Excellence Across Industries
        </div>
        <p className="text-white text-center">
          At the heart of innovation, we provide tailored solutions that empower
          diverse industries to achieve their goals and surpass expectations.
        </p>
      </Container>
      {/* <Container
        className="aboutHeader row p-0 align-items-center justify-content-center"
        style={{ margin: "2rem auto" }}
      >
        <div
          className="aboutimgHeader col-lg-6 col-md-10 col-sm-12"
          style={{ overflow: "hidden", borderRadius: "18px" }}
        >
          <img src={Img1} alt="Img1" />
        </div>
        <div className="aboutHeaderText1 col-lg-6 col-md-10 text-center text-lg-start px-4">
          <div className="Heading43 mt-5 mt-lg-0 mb-3">
            Driving Excellence Across Industries
          </div>
          <p>
            At the heart of innovation, we provide tailored solutions that
            empower diverse industries to achieve their goals and surpass
            expectations.
          </p>
          <Bluebutton Text="Get in Touch" Link="contact" />
        </div>
      </Container> */}
      {/* <h1
        className="Heading43 mt-5"
        style={{ textAlign: "center", margin: "0rem 0rem 4rem 0rem" }}
      >
        Our Working Areas
      </h1> */}

      <Container className="workingAreasContainer">
        <div className="row">
          {workingAreas.map((area, index) => (
            <div
              className="col-lg-4 px-2 col-md-6 col-sm-12 workingAreaItem"
              key={index}
            >
              <div className="workingAreaCard text-center mb-5">
                <div className="d-flex gap-3 align-items-center">
                  {/* <img
                    src={Briefcase}
                    alt="Briefcase"
                    className="workingAreaIcon"
                  /> */}
                  <area.icon size={100} color="#272727" />
                  <div>
                    <h3
                      className="workingAreaTitle text-start"
                      style={{ color: "var(--primary-varient)" }}
                    >
                      {area.title}
                    </h3>
                    <p className="workingAreaDescription text-start">
                      {area.description}
                    </p>
                    {/* <Link to={`/${area.Link}`} className="removeLinkDecoration">
                      <button
                        className="bluebutton"
                        style={{
                          color: "var(--primary-color)",
                          "background-color": "white",
                          padding: "0px",
                          border: "0px solid var(--primary-color)",
                        }}
                      >
                        Read More <img src={ArrowTop} alt="Arrow" />
                      </button>
                    </Link> */}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
     
      <Footer />
    </>
  );
};

export default OurWorkingAreas;
